import React from 'react';

import * as NotificationHelper from '../../../helpers/notificationHelper';

import { callApi } from 'helpers/callApi/callApi';
import AppModal from 'components/modal/appModal';
import { ResetRenderModalContentProps } from './ResetRenderModal.types';

export const ResetRenderModalContent = ({
  resetParticipantRender,
  data: { event, participantId },
  id,
  close,
}: ResetRenderModalContentProps) => {
  const handleSubmit = () => {
    callApi({
      action: () =>
        resetParticipantRender(event.id, {
          participantId,
        }),
      onSuccess: () => {
        NotificationHelper.success('Successfully reset render limit!');
        close();
      },
      onFailure: () => {
        NotificationHelper.error('Error resetting render limit. Please try again.');
      },
    });
  };

  return (
    <AppModal
      id={id}
      title="Reset Render"
      hideOpenButton
      submitButtonLabel="Yes"
      closeButtonLabel="No"
      submitAction={handleSubmit}
    >
      <h5>Are you sure you want to reset render limit for this participant?</h5>
    </AppModal>
  );
};
